// Librerias
import React from 'react'
import { AutoSizer, Table, Column } from 'react-virtualized'
// API
import api from '../../apiClient/v1'
// Componentes
import Modal from 'react-bootstrap/lib/Modal.js'
// Style
import classNames from 'classnames/bind'
import * as cssModal from '../../inventarios/diferencias-inventarios/modal.css'
let css = classNames.bind(cssModal)

export class ModalTrigger extends React.Component{
    constructor(props){
        super(props)
        this.state = { visible: false }
        this.show  = ()=> this.setState({visible: true})
        this.hide  = ()=> this.setState({visible: false})
    }
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
}
export class ModalDetalle extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false
        }
        this.handleSubmit = (evt)=>{
           this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.props.generarFactura()
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Valores</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.totalFacturaAnterior}</span>
                            Valor facturadas anteriormente
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.valorActual}</span>
                            Valor realizadas
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.diferencia}</span>
                            Diferencia a facturar
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={this.handleSubmit}>
                        <button type={'submit'} className={'btn btn-primary'} disabled={this.state.bloqueado}>{this.state.notaCredito?'Nota Credito':'Facturar'}</button>
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                    </form>
                </Modal.Footer>
            </Modal>
        )
    }
}
export class ModalDetalleCliente extends React.Component{
    constructor(props) {
        super(props)
        this.state = {
            bloqueado: false
        }
        this.handleSubmit = (evt)=>{
            this.setState({bloqueado: true})
            evt.preventDefault()
            evt.stopPropagation()
            this.setState(()=>{
                this.props.generarCorreo()
                    .then(()=>{
                        this.setState({bloqueado: false})
                        this.props.hideModal()
                    })
                    .catch(error=>{
                        console.log("error")
                    })
            })
        }
    }
    render() {
        return (
            <Modal show={true} onHide={this.props.hideModal} className={css('modale')}>
                <Modal.Header closeButton>
                    <Modal.Title>Información de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul className={'list-group'}>
                        <strong>Valores</strong>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.totalFacturaAnterior}</span>
                            Valor facturado anteriormente
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.valorActual}</span>
                            Valor mes
                        </li>
                        <li className={'list-group-item'}>
                            <span className={'badge'}>{this.props.diferencia}</span>
                            Diferencia a facturar neto
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={this.handleSubmit}>
                        <button type={'submit'} className={'btn btn-primary'} disabled={this.state.bloqueado}>{'Informar aprobación'}</button>
                        <button type={'button'} className={'btn btn-secondary'} onClick={this.props.hideModal}>Cancelar</button>
                    </form>
                </Modal.Footer>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/resumen-mensual/Modales.jsx